import {Component, HostListener} from '@angular/core';
import {LayoutService} from '../../../../core/services/layout.service';
import {AsyncPipe, NgClass} from "@angular/common";
import {Observable} from "rxjs";
import {ThemeToggleButtonComponent} from "../../../../shared/components/theme-toggle/theme-toggle-button.component";
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [
    AsyncPipe,
    NgClass,
    ThemeToggleButtonComponent,
  ],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
})
export class AppHeaderComponent {

  isMobileOpen$!: Observable<boolean>;
  isProfileOpen = false; 

  constructor(public layoutService: LayoutService) {
    // ✅ Safe: constructor runs AFTER dependency injection
    this.isMobileOpen$ = this.layoutService.isMobileOpen$;
  }

  toggleSidebar() {
    if (window.innerWidth < 1200) {
      this.layoutService.toggleMobileOpen();
    } else {
      this.layoutService.toggleExpanded();
    }
  }


  toggleProfileDropdown(): void {
    this.isProfileOpen = !this.isProfileOpen;
  }

  logout(): void {
    console.log('Logout clicked');
  }

  // 👇 Close dropdown on outside click
  @HostListener('document:click', ['$event'])
  closeOnOutsideClick(event: Event): void {
    const target = event.target as HTMLElement;

    if (!target.closest('.position-relative')) {
      this.isProfileOpen = false;
    }
  }

}
